export default function CTASection() {
  return (
    <section id="explore" className="relative w-full h-[75vh] min-h-[520px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20vibrant%20colorful%20streetwear%20fashion%20items%20including%20neon%20lime%20green%20sneakers%20bright%20orange%20beanie%20hat%20rainbow%20striped%20socks%20holographic%20iridescent%20accessories%20and%20tie%20dye%20tshirt%20scattered%20organically%20on%20pure%20clean%20white%20surface%20bright%20daylight%20clean%20editorial%20product%20photography%20energetic%20cheerful%20mood%20pop%20aesthetic&width=1600&height=1200&seq=cta-bg-css-v2-2026&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-background-50/45"></div>

      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-6 max-w-[680px]">
          <h2 className="text-[44px] md:text-[56px] font-bold text-foreground-950 font-heading leading-[1.08] tracking-[-0.01em] uppercase">
            Start Exploring
          </h2>
          <p className="mt-5 text-[16px] md:text-[18px] text-foreground-600 leading-relaxed max-w-[480px] mx-auto">
            Access updated CSSBuy spreadsheet database, compare agent lists, and find trending streetwear items instantly.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 h-[56px] px-8 bg-foreground-900 text-background-50 rounded-full text-[15px] font-medium hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap"
            >
              <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-shopping-bag-line text-background-50 text-base w-5 h-5 flex items-center justify-center"></i>
              </span>
              cssbuy sheet
              <i className="ri-arrow-right-up-line text-background-50/70 w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 h-[56px] px-8 bg-background-50 border border-secondary-300 text-foreground-800 rounded-full text-[15px] font-medium hover:border-foreground-400 transition-all duration-200 whitespace-nowrap"
            >
              buy it now
              <i className="ri-arrow-right-up-line text-foreground-500 w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}